/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-02T16:30:29.152
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialRentContractItemPaymentCollectionMonth,
	listReportFinancialRentContractItemPaymentCollectionMonthInit,
	listReportFinancialRentContractItemPaymentCollectionMonthByAuthorizations,
	deleteReportFinancialRentContractItemPaymentCollectionMonth
	
} from '@api/report/ReportFinancialRentContractItemPaymentCollectionMonth';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialRentContractItemPaymentCollectionMonth({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractItemPaymentCollectionMonth(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialRentContractItemPaymentCollectionMonthByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractItemPaymentCollectionMonthByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialRentContractItemPaymentCollectionMonthInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialRentContractItemPaymentCollectionMonthInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialRentContractItemPaymentCollectionMonth({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialRentContractItemPaymentCollectionMonth({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
